module.exports = __webpack_public_path__ + "static/media/help05.6d33ce73.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help/help05.png
// module id = 429
// module chunks = 0